import {
  ButtonLooks,
  ButtonSizes,
  DialogSizes,
  StandardButton,
  StandardDialog,
  brandfolderColorPalette
} from '@brandfolder/react';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(StandardDialog)`
  .bf-dialog__type {
    height: fit-content;
    min-height: unset;
  }

  .bf-dialog__inner {
    height: fit-content;
  }

  .bf-dialog__body {
    padding: 0 24px 24px;
  }

  .bf-dialog__footer {
    margin-top: 0;
  }

  p {
    color: ${brandfolderColorPalette.neutrals[700]};
    font-size: 14px;
    line-height: 1.5;
  }

  .bf-dialog__footer {
    padding: 0px 30px 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

interface PeopleTagScopeConfirmModalProps {
  isOpen: boolean;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  onClose: () => void;
}

export const PeopleTagScopeConfirmModal: FunctionComponent<PeopleTagScopeConfirmModalProps> = ({
  isOpen,
  onPrimaryAction,
  onSecondaryAction,
  onClose
}) => (
  <StyledDialog
    className="people-tag-scope-confirm-modal"
    footer={
      <ButtonContainer>
        <StandardButton
            look={ButtonLooks.Secondary}
            onClick={onSecondaryAction}
            size={ButtonSizes.XSmall}
        >
            <Trans>Only this asset</Trans>
        </StandardButton>
        <StandardButton
          look={ButtonLooks.Primary}
          onClick={onPrimaryAction}
          size={ButtonSizes.XSmall}
        >
          <Trans>All x assets across brandfolder</Trans>
        </StandardButton>
    </ButtonContainer>
    }
    id="people-tag-scope-confirm-modal"
    labels={{
      closeButtonLabel: t`Close`
    }}
    open={isOpen}
    setOpen={(open): void => {
      if (!open) onClose();
    }}
    showTitle
    size={DialogSizes.Small}
    title={t`How would you like to apply this update?`}
  >
    <p>
      <Trans>
          You're editing the people tag for this asset. Do you want to
          update this identity only for this asset, or apply the changes
          across all x assets where this identity appears in Brandfolder?
      </Trans>
    </p>

  </StyledDialog>
);
